<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-group label-for="input-timezone">
      <template #label>
        My timezone
      </template>
      <timezone-input id="input-timezone" v-model="form.timezone" :state="isValidField('timezone')" class="rounded-pill" />
      <b-form-invalid-feedback :state="isValidField('timezone')">
        <div v-for="error in errors.timezone || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-best-time">
      <template #label>
        Best time to catch me
      </template>
      <b-form-input
        id="input-best-time"
        v-model="form.bestTime"
        :state="isValidField('bestTime')"
        placeholder="e.g.: during lunch break, from 10am to 12am, Wed-Thurs., ..."
        class="rounded-pill"
      />
      <b-form-invalid-feedback :state="isValidField('bestTime')">
        <div v-for="error in errors.bestTime || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-favorite-channels">
      <template #label>
        Best way to reach me
      </template>
      <channels id="input-favorite-channels" v-model="form" size="1.7rem" selectable />
    </b-form-group>
    <b-row align-v="end" class="mt-5">
      <b-col>
        <b-button :disabled="submitting" pill variant="outline-primary" class="pl-5 pr-5" @click.prevent="$emit('back')">Back</b-button>
      </b-col>
      <b-col cols="6" md="auto" class="text-center">
        <b-button :disabled="submitting" variant="link" class="btn-link-primary mb-2 mb-md-0" @click.prevent="$emit('skip')">Skip or</b-button>
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">{{ submitText }}</b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import TimezoneInput from '@/components/common/TimezoneInput'
import Channels from '@/components/common/Channels'
import MixinForm from '../MixinForm'
import { CurrentTimezone } from '@/helpers/helpers'

export default {
  name: 'ContactForm',

  mixins: [MixinForm],

  props: {
    submitText: {
      type: String,
      default: 'Next'
    },

    data: {
      type: Object,
      default: () => ({})
    }
  },

  watch: {
    data(value) {
      Object.assign({}, this.form, value)
    }
  },

  data() {
    const {
      bestTime, canCall, canEmail, canTalk, canText,
      canVideo, canSlack, canZoom, canHangout, timezone
    } = this.data
    return {
      form: {
        timezone: timezone || CurrentTimezone,
        bestTime: bestTime,
        canCall: canCall,
        canEmail: canEmail,
        canTalk: canTalk,
        canText: canText,
        canVideo: canVideo,
        canSlack: canSlack,
        canZoom: canZoom,
        canHangout: canHangout
      }
    }
  },

  components: {
    TimezoneInput,
    Channels
  }
}
</script>
